import { styled } from "@mui/material";

export const GridStyled = styled("div")`
	display: flex;
	justify-content: center;
	gap: 15px;
`;
